module.exports = __webpack_public_path__ + "img/129.8887c6f1.jpg";